import { FC, SVGProps } from 'react';

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.16882 14.8312C4.5233 14.8312 4 15.3545 4 16C4 16.6455 4.5233 17.1688 5.16882 17.1688L14.8312 17.1688L14.8312 26.8312C14.8312 27.4767 15.3545 28 16 28C16.6455 28 17.1688 27.4767 17.1688 26.8312L17.1688 17.1688H26.8312C27.4767 17.1688 28 16.6455 28 16C28 15.3545 27.4767 14.8312 26.8312 14.8312H17.1688L17.1688 5.16882C17.1688 4.5233 16.6455 4 16 4C15.3545 4 14.8312 4.5233 14.8312 5.16882L14.8312 14.8312H5.16882Z"
			fill="currentColor"
		/>
	</svg>
);
